import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/NutOutline.tsx
import React from "react";
var SvgNutOutline, NutOutline_default;
var init_NutOutline = __esm({
  "src/icons/NutOutline.tsx"() {
    SvgNutOutline = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.625 6.725c1.251-1.426 3.272-2.469 6.283-2.469 3.012 0 5.05 1.043 6.33 2.457 1.248 1.378 1.7 3.025 1.732 4.169l.03 1.08H4V10.91c0-1.143.408-2.798 1.625-4.185Zm.689 3.133H17.62a4.735 4.735 0 0 0-1-1.754c-.833-.92-2.26-1.745-4.712-1.745s-3.846.825-4.643 1.733a4.545 4.545 0 0 0-.951 1.766Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.87 2h3.586v2.103h-1.429V5.27H10.87V2ZM5.042 10.947H7.2v4.587c0 1.467.7 2.534 1.652 3.262.984.753 2.188 1.1 3.018 1.1.972 0 2.171-.19 3.097-.804.855-.567 1.611-1.58 1.611-3.558v-4.587h2.158v4.587c0 2.61-1.057 4.304-2.555 5.297-1.429.947-3.123 1.17-4.311 1.17-1.33 0-3-.518-4.351-1.55-1.382-1.058-2.477-2.699-2.477-4.917v-4.587Z",
          clipRule: "evenodd"
        }
      )
    );
    NutOutline_default = SvgNutOutline;
  }
});

export {
  NutOutline_default,
  init_NutOutline
};
